
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import { GeocodeResult } from '@googlemaps/google-maps-services-js';

import GoogleMaps from '../../anonymous/GoogleMaps.vue';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import AutoCompleteField from '../../../../framework/fields/AutoCompleteField.vue';
import EmailField from '../../../../framework/fields/EmailField.vue';

import { sharedState } from '../../../../framework/state';
import { getResource, putResource } from '../../../../framework/client/resource';
import { getEnumerationOptions } from '../../../../framework/service/options';

import { VendorType } from '../../../../../common/application/model/enums/VendorType';
import { VendorLocation } from '../../../../../common/application/model/VendorLocation';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { parseGeocodeResult } from '../../../../../common/application/service/google_maps_service';

import { successToast, errorToast } from '../../../service/toast_service';
import { getAutoCompleteFieldParams } from '../../../service/query_parameter_service';

@Component({
    components: {
        SelectField,
        TextField,
        AutoCompleteField,
        EmailField,
        ValidationObserver,
        GoogleMaps,
    },
})
export default class EditVendorLocation extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VENDOR_LOCATION;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as VendorLocation,
        vendorTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.vendorTypeOptions = getEnumerationOptions('VendorType', Object.keys(VendorType), this);
        this.local.row = (await getResource<VendorLocation>(this.resourceType, this.id))!!;
    }

    async save() {
        await this.saveResource();
    }

    async saveAndClose() {
        await this.saveResource(true);
    }

    async saveResource(goBack?: boolean): Promise<void> {
        try {
            await putResource(this.resourceType, this.id, this.local.row);
            successToast(this, 'message.vendorLocationSaved');

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }

    get fullAddress(): string {
        if (!this.local.row.street) {
            return '';
        }

        return `${this.local.row.street}, ${this.local.row.zip} ${this.local.row.city}`;
    }

    get vendorSelectorParams(): Map<string, string> {
        return getAutoCompleteFieldParams('id', {});
    }

    setAddress(geocodeResult: GeocodeResult) {
        const parsedLocation = parseGeocodeResult(geocodeResult);

        this.local.row = {
            ...this.local.row,
            street: parsedLocation.street,
            zip: parsedLocation.zip,
            city: parsedLocation.city,
            country: parsedLocation.country,
            lat: parsedLocation.lat,
            lng: parsedLocation.lng,
        };
    }
}
